module.exports = __webpack_public_path__ + "static/img/serverSwiperOne.786736f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/serverSwiperOne.png
// module id = wgMk
// module chunks = 1